import { useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";

export default function RentPaidPage() {
  const [params] = useSearchParams();
  const ok = params.get("status") !== "cancelled";
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center px-6 py-24 text-center" data-testid="rent-paid-page">
      {ok ? (
        <>
          <CheckCircle2 className="h-16 w-16 text-emerald-500" />
          <h1 className="mt-6 font-display text-3xl">Rent payment received</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            Thank you — your payment has been processed securely by Stripe. Your landlord has been notified automatically. You can close this page.
          </p>
        </>
      ) : (
        <>
          <XCircle className="h-16 w-16 text-red-400" />
          <h1 className="mt-6 font-display text-3xl">Payment cancelled</h1>
          <p className="mt-3 text-sm text-muted-foreground">
            No charge was made. You can reopen the payment link your landlord sent you to try again.
          </p>
        </>
      )}
      <p className="mt-10 text-xs text-muted-foreground">Powered by Zuntria · Secure payments via Stripe</p>
    </div>
  );
}
